import React, { useState } from 'react';
import Modal from '../common/Modal';
import { authService } from '../../services/auth.service';
import { chatService } from '../../services/api';
import { useLanguage } from '../../context/LanguageContext';

const AuthModal = ({ isOpen, onClose, setMessages, setConversations }) => {
  const { t } = useLanguage();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isSignUp, setIsSignUp] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    
    try {
      if (isSignUp) {
        await authService.signUp(email, password);
        setMessages(prev => [...prev, {
          role: 'assistant',
          content: t('emailConfirmation'),
          isTyping: false
        }]);
      } else {
        await authService.signIn(email, password);
        try {
          const conversations = await chatService.getConversations();
          setConversations(conversations);
        } catch (error) {
          console.error('Error loading conversations:', error);
        }
      }
      onClose();
    } catch (error) {
      setError(error.message);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="space-y-4">
        <h3 className="text-lg font-semibold text-gray-900">
          {isSignUp ? t('createAccount') : t('signInTitle')}
        </h3>
        {error && (
          <div className="text-red-500 text-sm">
            {error}
          </div>
        )}
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder={t('email')}
              className="w-full p-2 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>
          <div>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder={t('password')}
              className="w-full p-2 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>
          <div className="flex justify-between items-center">
            <button
              type="button"
              onClick={() => setIsSignUp(!isSignUp)}
              className="text-blue-600 text-sm hover:text-blue-500"
            >
              {isSignUp ? t('alreadyHaveAccount') : t('dontHaveAccount')}
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-400"
            >
              {isSignUp ? t('register') : t('signInTitle')}
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default AuthModal;
